const initialState = () => ({
    all: []
});

const typeDocReducer = (state = initialState(), action) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'TYPE_DOC_RECEIVED':
            newState.all = action.payload.sort((a, b) => {
                if (a.label > b.label) return 1;
                if (a.label< b.label) return -1;
                return 0;
            });
            return newState;
        case 'LOGOUT':
            return Object.assign({}, initialState());
        default:
            return state;
    }
};

export default typeDocReducer;

